const isStringEmpty =  (values, value, type) =>
  ![value.length > 0, value.trim().length === 0].every((el) => el === true);
export default isStringEmpty;